import React, { useState } from 'react';
import { Pie } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    ArcElement,
    Tooltip,
    Legend,
} from 'chart.js';
import '../sip/Calculators.css';

ChartJS.register(ArcElement, Tooltip, Legend);

const MarriageCalculator = () => {
    const [currentAge, setCurrentAge] = useState(25);
    const [marriageAge, setMarriageAge] = useState(30);
    const [monthlyInvestment, setMonthlyInvestment] = useState(10000);
    const [expectedReturn, setExpectedReturn] = useState(12);
    const [futureCost, setFutureCost] = useState(1000000);
    const [results, setResults] = useState(null);
    const [pieData, setPieData] = useState(null);

    const calculateMarriagePlan = () => {
        const years = marriageAge - currentAge;
        const months = years * 12;
        const sipRate = expectedReturn / 100 / 12;
        const lumpsumRate = expectedReturn / 100;

        const sipValue =
            monthlyInvestment *
            ((Math.pow(1 + sipRate, months) - 1) / sipRate) *
            (1 + sipRate);

        const lumpsumRequired = futureCost / Math.pow(1 + lumpsumRate, years);

        const investedAmount = monthlyInvestment * months;
        const growth = sipValue - investedAmount;

        setResults({
            futureCost: Math.round(futureCost),
            sipValue: Math.round(sipValue),
            lumpsumRequired: Math.round(lumpsumRequired),
        });

        setPieData({
            labels: ['Invested Amount', 'Growth'],
            datasets: [
                {
                    data: [Math.round(investedAmount), Math.round(growth)],
                    backgroundColor: ['#004aad', '#76d041'],
                    borderWidth: 1,
                },
            ],
        });
    };

    return (
        <div className="sip-calculator">
            <h2>Marriage Planning Calculator</h2>

            <div className="input-group">
                <label>Current Age</label>
                <input type="range" min="18" max="60" value={currentAge} onChange={(e) => setCurrentAge(Number(e.target.value))} />
                <input
                    type="number"
                    min="18"
                    max="60"
                    value={currentAge}
                    onChange={(e) => setCurrentAge(Number(e.target.value))}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Planned Marriage Age</label>
                <input type="range" min={currentAge + 1} max="80" value={marriageAge} onChange={(e) => setMarriageAge(Number(e.target.value))} />
                <input
                    type="number"
                    min={currentAge + 1}
                    max="80"
                    value={marriageAge}
                    onChange={(e) => setMarriageAge(Number(e.target.value))}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Monthly Investment (₹)</label>
                <input type="range" min="500" max="100000" value={monthlyInvestment} onChange={(e) => setMonthlyInvestment(Number(e.target.value))} />
                <input
                    type="number"
                    min="500"
                    max="100000"
                    value={monthlyInvestment}
                    onChange={(e) => setMonthlyInvestment(Number(e.target.value))}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Expected Annual Return (%)</label>
                <input type="range" min="1" max="30" value={expectedReturn} onChange={(e) => setExpectedReturn(Number(e.target.value))} />
                <input
                    type="number"
                    min="1"
                    max="30"
                    value={expectedReturn}
                    onChange={(e) => setExpectedReturn(Number(e.target.value))}
                    className="value-box"
                />
            </div>

            <div className="input-group">
                <label>Estimated Cost of Marriage (₹)</label>
                <input type="range" min="100000" max="10000000" step="10000" value={futureCost} onChange={(e) => setFutureCost(Number(e.target.value))} />
                <input
                    type="number"
                    min="100000"
                    max="10000000"
                    step="10000"
                    value={futureCost}
                    onChange={(e) => setFutureCost(Number(e.target.value))}
                    className="value-box"
                />
            </div>

            <button className="calculate-btn" onClick={calculateMarriagePlan}>Calculate</button>

            {results && pieData && (
                <div className="sip-output-section">
                    <div className="result-summary">
                        <h3>Results</h3>
                        <p>Total Amount Required at Marriage:
                            <strong style={{color:'#76d041'}}> ₹
                            {results.futureCost.toLocaleString()}</strong>
                        </p>
                        <p>Planning Through SIP:
                            <strong style={{color:'#76d041'}}> ₹
                            {results.sipValue.toLocaleString()}</strong>
                        </p>
                        <p>Planning Through Lumpsum:
                            <strong style={{color:'#76d041'}}> ₹
                            {results.lumpsumRequired.toLocaleString()}</strong>
                        </p>
                    </div>

                    <div className="pie-chart-container">
                        <h3>Principal vs Growth</h3>
                        <Pie data={pieData} />
                    </div>
                </div>
            )}
        </div>
    );
};

export default MarriageCalculator;
